<template>
  <div class="row print-machine-operations">
    <div class="col-6">
            <div class="row">
                <div class="col mx-2">
                    <form class="form-inline py-2 justify-content-start" >
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-back btn-lg" @click="$router.push(`/settings/print-machines/card/${printMachineId}`)">
                            <i class="fa fa-angle-left px-1"></i>
                        </button>
                        <h2 class="ml-2">{{printMachineName}} / Настройка стоимости</h2>
                    </div>
                    </form>
                </div>
            </div>
             <div class="row mt-4">
                <div class="col mx-2">
                    <div class="input-group with-clear-icon">
                        <input type="text" class="form-control" v-model="searchText">
                        <i class="ico ico-close" @click="clearSearchText" v-if="searchText.length > 0"></i>
                        <div class="input-group-append">
                            <span class="input-group-text"><i class="fa fa-search"></i></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col mx-2">
                     <router-link class="btn btn-outline-primary" :to="`/settings/print-machine-operations/${printMachineId}/operation-card/0`" tag="button" :disabled="$route.path===`/settings/print-machine-operations/${printMachineId}/operation-card/0`">
                          <i class="ico ico-plus mr-2"></i>Добавить шаблон
                    </router-link>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col mx-2">
                    <ul class="list-unstyled operation-items">
                        <router-link class="operation-item mt-2 px-4" :to="`/settings/print-machine-operations/${printMachineId}/operation-card/${operation.id}`" tag="li" v-for="operation in operations"
                            :key="operation.id" :class="{'operation-item-disabled' : !operation.enabled}">
                            <span class="operation-item-name" :title="operation.name">{{operation.name}}</span>
                        </router-link>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-6">
            <router-view></router-view>
        </div>
  </div>
</template>

<script>
import api from '../../../api'
import { sortBy } from 'lodash'

const mapOperation = operation => {
  return {
    id: operation.id,
    name: operation.name,
    enabled: operation.enabled
  }
}

export default {
  name: 'PrintMachineOperations',
  props: {
    printMachineId: {
      default: null
    }
  },
  data: () => {
    return {
      searchText: '',
      printMachineOperations: [],
      printMachineName: ''
    }
  },
  methods: {
    loadPrintMachineOperations (pmId) {
      api.get
        .printMachineOperations(pmId)
        .then(resp => {
          this.printMachineOperations = (resp.data.data.operations || [])
            .map(mapOperation)
            .sort(function (a, b) {
              if (a.name > b.name) {
                return 1
              }
              if (a.name < b.name) {
                return -1
              }
              return 0
            })
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    clearSearchText () {
      this.searchText = ''
    },
    loadPrintMachineName (pmId) {
      api.get
        .printMachine(pmId)
        .then(resp => {
          this.printMachineName = resp.data.data.printMachine.name.toUpperCase()
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    }
  },
  computed: {
    pmId () {
      return +this.printMachineId
    },
    operations () {
      const sortedOperations = sortBy(this.printMachineOperations, (operation) => operation.name.toLowerCase())
      if (this.searchText) {
        return sortedOperations.filter(x => x.name.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0)
      }

      return sortedOperations
    }
  },
  created: function () {
    this.loadPrintMachineOperations(this.pmId)
    this.loadPrintMachineName(this.pmId)
    this.$eventBus.$on('updatePrintMachineOperations', () => {
      this.loadPrintMachineOperations(this.pmId)
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'настройки операций')
    })
  }
}
</script>

<style>

</style>
